import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-newsletters-type02',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, HeadingSectionType01Component, SlickCarouselModule, FormsModule],
  templateUrl: './newsletters-type02.component.html',
  styleUrl: './newsletters-type02.component.scss'
})
export class NewslettersType02Component implements OnInit {

  public view: any = {
    message: null
  }

  constructor(public _tfmService : TFMService, private route: ActivatedRoute) {

  }

  ngOnInit(): void {
      this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        // this._tfmService.log(this.view);

      });
  }

  public addSub() {
    if (this.view.emailAddress) {
      var content : any = {
        emailAddress: this.view.emailAddress,
        group:"Website"
      }
      this._tfmService.addSubscriber(content).subscribe(res => {
        this.view.message = "Thank you!";

        setTimeout(() => {
          this.view.message = null;
        }, 5000);
      });
    }
  }
}
